import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackSignUpParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackSignUp";

const useTrackSignUp = (parameters: TrackSignUpParameters = {}, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.util.getEventTrackerHook(ga.track.signUp, parameters, options);
};

export default useTrackSignUp;
